<template>
  <div id="onboarding">
    <v-dialog
      v-model="dialog"
      max-width="800"
      persistent
      overlay-opacity="0.85"
    >
      <v-card elevation="0">
        <video
          id="welcome-video"
          poster="https://pjili-public.s3.ca-central-1.amazonaws.com/auctions/assets/img/welcome_poster.png"
          playsinline
          controls
          class="video"
          style="{maxHeight: 390px}"
          v-if="videoEnabled"
        >
          <source src="https://pjili-public.s3.ca-central-1.amazonaws.com/auctions/assets/videos/Welcome+Video.mp4" />
        </video>

        <!-- show the row below before onboarding started -->
        <v-row 
          class="mt-5"
          justify="space-around"
          v-if="!startStarted"
        >
          <v-col cols="5" class="text-center">
            <v-btn
              exact
              @click="dismissWelcomeDialog()"
              block
              v-bind="btnSize"
            >
              Don't Show Again
            </v-btn>
          </v-col>
          <v-col 
            cols="5"
            class="text-caption text-center"
            @click="startOnboarding()"
          >
            <v-btn
              v-bind="btnSize"
              exact block color="primary"
              >Help me Setup</v-btn
            >
          </v-col>
        </v-row>

        <!-- show the row below when onboarding started -->
        <v-row v-if="startStarted">
          <v-col>

            <v-stepper
              v-model="onboarding.step"
              vertical
            >
              <v-stepper-step
                :complete="hasNickname"
                @click="selectedStep(1)"
                step="1"
              >
                Choose a nickname
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-card>
                  <v-card-text>
                    <v-text-field
                      v-model="newNickname"
                      :placeholder="user.Nickname"
                      counter="25"
                      maxlength="25"
                      :error-messages="errorMessages"
                      outlined
                      append-icon="mdi-account-circle-outline"
                    ></v-text-field>
                    <p class="green--text" v-if="nicknameAvailable">
                      Nickname is available
                    </p>
                    <p v-show="nicknameCheckStatus">{{ nicknameCheckStatus }}</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveNickname">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>

              <v-stepper-step
                step="2"
                :complete="user.Balance > 0"
              >
                Get tokens
              </v-stepper-step>

              <v-stepper-content step="2">
                <v-btn
                  color="primary"
                  @click="addPayment()"
                >
                  Get tokens
                </v-btn>
              </v-stepper-content>
            </v-stepper>

            <v-divider></v-divider>

            <v-row 
              class="mt-5"
              justify="space-around"
            >
              <v-col cols="5" class="text-center">
                <v-btn
                  exact
                  @click="dismissWelcomeDialog()"
                  block
                  v-bind="btnSize"
                >
                  Don't Show Again
                </v-btn>
              </v-col>

              <v-col 
                cols="5"
                class="text-caption text-center"
                @click="close()"
              >
                <v-btn
                  v-bind="btnSize"
                  exact block color="primary"
                  >
                  Close
                </v-btn>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "OnboardingV2",
  data() {
    return {
      startStarted: false,
      videoEnabled: true,
      dialog: null,
      errorMessages: [],
      doNotShowSwitch: false,
      newNickname: null,
      nicknameAvailable: false,
      nicknameCheckStatus: null
    };
  },
  computed: {
    ...mapState([
      "onboarding",
      "hasNickname",
      "cfg"
    ]),
    ...mapGetters([
      "user",
    ]),
    btnSize() {
      const size = {xs:'x-small',sm:'small',lg:'large',xl:'x-large'}[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },
  watch: {
    // whenever question changes, this function will run
    newNickname: function () {
      this.nicknameCheckStatus = "Waiting for you to stop typing...";
      this.debouncedCheckNickname();
    }
  },
  methods: {
    ...mapActions([
      "nextStep",
      "selectedStep",
      "showBuyTokensDialog",
    ]),
    startOnboarding(){
      this.startStarted = true
    },
    close() {
      this.dialog = false;
      this.videoEnabled = false;
    },
    addPayment(){
      this.dialog = false;
      this.$router.push({name: 'purchase-tokens', query: {continue: '/'}});
    },
    dismissWelcomeDialog(){
      this.$axios
        .post(`${this.cfg.API_URL}users/welcome_modal_dismiss`)
        .then(() => {
          this.dialog = false;
        });
    },
    saveNickname(){
      this.$axios
        .post(this.$cfg.API_URL + "users/set-nickname", {
          nickname: this.newNickname,
        })
        .then(() => {
          this.$store.dispatch("FetchUser");
          this.nicknameCheckStatus = null;
          this.nicknameAvailable = null;
          this.errorMessages = [];
          this.selectedStep(2)
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.errorMessages = error.response.data.errors;
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.errors = ["Network error"];
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errors = [
              "We're really sorry our systems seems to be unhealty now. Please try again later or contact us.",
            ];
          }
        });
    },
    checkNickname(){
      this.nicknameCheckStatus = "Checking if nickname is available...";
      this.$axios
        .post(this.$cfg.API_URL + "users/check-nickname", {
          nickname: this.newNickname,
        })
        .then(() => {
          this.errorMessages = [];
          this.nicknameAvailable = true;
          this.nicknameCheckStatus = null;
        })
        .catch((error) => {
          this.nickNameStatus = null;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.errorMessages = error.response.data.errors;
            this.nicknameAvailable = false;
            this.nicknameCheckStatus = null;
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.errors = ["Network error"];
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errors = [
              "We're really sorry our systems seems to be unhealty now. Please try again later or contact us.",
            ];
          }
        });
    },
  },
  created() {
    this.debouncedCheckNickname = this.$_.debounce(this.checkNickname, 1000);

    if(this.user && this.user.ShowWelcome && this.hasNickname && this.user.Balance > 0){
      this.dismissWelcomeDialog()
    }else if(this.user && this.user.ShowWelcome) {
      this.dialog = true;
    } else {
      this.dialog = false
    }
  },
};
</script>

<style lang="scss">
#no-background-hover::before {
  background-color: transparent !important;
}
.v-stepper__step:hover {
  cursor: pointer;
}

.v-input--switch label {
  font-size: 0.95rem !important;
}
</style>